import { ChevronRight, User } from 'lucide-react'
import CastPortraitTile from './CastPortraitTile'
import type { CastPortrait } from './castPortraits'

type CastSpotlightProps = {
  portraits: CastPortrait[]
  onOpenPerson: (personId: string) => void
  onViewAll: () => void
}

export default function CastSpotlight({ portraits, onOpenPerson, onViewAll }: CastSpotlightProps) {
  return (
    <section className="cast-spotlight" aria-label="Cast spotlight">
      <header className="cast-spotlight__header">
        <div>
          <span className="eyebrow"><User size={13} /> CAST SPOTLIGHT</span>
          <h2>Follow the cast conversation</h2>
          <p>Open a profile, follow them, or tag them in your next post.</p>
        </div>
        <button type="button" onClick={onViewAll}>View all <ChevronRight size={14} /></button>
      </header>
      <div className="cast-spotlight__rail">
        {portraits.map((portrait) => (
          <CastPortraitTile key={portrait.personId} portrait={portrait} onOpen={() => onOpenPerson(portrait.personId)} />
        ))}
      </div>
    </section>
  )
}
